// extracted by mini-css-extract-plugin
export default {"ask-why-tab":"AskWhyTab_ask-why-tab__0ILmq","ask-why-tab-link":"AskWhyTab_ask-why-tab-link__IUkhP","ask-why-tab-iframe":"AskWhyTab_ask-why-tab-iframe__PGigO"};